module.exports = __webpack_public_path__ + "static/media/Tanzania-Queen-and-Son-small.ccf1d0ff.jpg";